import styled from 'styled-components';

export const Wrapper = styled.div`
  

  & .modal-iptu-backdrop {
    background: rgba(0,0,0,0.5);
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    text-align: center;

        & .modal-iptu-content {
          position: relative;
          height: 100%;
          width: fit-content;
          margin: 0 auto;

          & .close-button {
            position: absolute;
            right: 0;
            background: #fff;
            border-radius: 100%;
            padding: 8px;
            cursor: pointer;
            top: 4%;

            @media only screen and (max-width: 600px) {
              right: 20px;
              top: 10%;
            }
          }
  
          & .modal-iptu-content-image {
              padding-top: 50px;
              height: 93%;
              top: 5%;
              left: 0px;
              width: initial;
              margin: 0 auto;
  
              @media only screen and (max-width: 600px) {
                  padding-top: 100px;
                  height: auto;
                  width: 95%;
              }
          }
          
        }

        
  }
`;

